import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { v4 as uuidv4 } from "uuid";
import { updateResponseService } from "../../services/ondcService";
import Loader2 from "../common/Loader2";
import { validateLogin } from "../../services/validate-login";
import { webSocketURL } from "../../services/endpointUrl";

function Form() {
  const [formIsComplete, setFormIsComplete] = useState(false); 
  const [formIsComplete2, setFormIsComplete2] = useState(false); 
  const [loading, setLoading] = useState(true); 
  const [lendersOffer, setLendersOffer] = useState<any>();
  const [lendersUrl, setLendersUrl] = useState("");
  const [popup, setPopup] = useState<Window | null>(null);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [paymentId, setPaymentId] = useState("");

  const navigate = useNavigate();

  const popupRef = useRef<Window | null>(null);
  useEffect(() => {
    setFormIsComplete(false)
    setFormIsComplete2(false)
    async function fetchOffers() {
      try {
        const data = {
          transaction_id: localStorage.getItem("transaction_id"),
          message_id: localStorage.getItem("update_id"),
        };
        console.log(data)
        const response = await updateResponseService(data);
        console.log(response)
        if (response.success) {
          setLendersUrl(response.message.response[0].payment.url);
          // Create WebSocket connection
          const ws = new WebSocket(webSocketURL);

          ws.onopen = () => {
            console.log("✅ Connected to WebSocket server");
            ws.send(localStorage.getItem("transaction_id")?? "");
          };

          ws.onmessage = (event) => {
            try {
              const ack = JSON.parse(event.data);
              console.log("📩 WS message:", ack);

              if (ack.success) {
                setFormIsComplete(true);
                setPaymentStatus(ack.message.status)
                setPaymentId(ack.message.payment_id)
                setFormIsComplete2(false)
                // Close popup if it's open
                if (popupRef.current && !popupRef.current.closed) {
                  popupRef.current.close();
                }else {
                }
                popupRef.current = null;
              }
            } catch (e) {
              console.error("Invalid WS data:", event.data);
            }
          };

          ws.onerror = (err) => {
            console.error("❌ WebSocket error:", err);
          };

          ws.onclose = () => {
            console.log("🔌 Disconnected from WebSocket server");
          };

          // Cleanup on component unmount
          return () => ws.close();
        }
      } catch (err) {
        console.error("Error fetching offers:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchOffers();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#f5f9ff]">
        <Loader2 />
      </div>
    );
  }

  const openPopup = () => {
    setFormIsComplete2(true)
    // Take 80% of screen size
    const width = Math.floor(window.screen.width * 0.8);
    const height = Math.floor(window.screen.height * 0.8);

    // Center the popup
    const left = Math.floor((window.screen.width - width) / 2);
    const top = Math.floor((window.screen.height - height) / 2);

    const features = `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars`;

    popupRef.current = window.open(
      lendersUrl,
      "popupWindow",
      features
    );
  };

  const onClickEvent = async () => {
    window.location.href = window.location.href;
  };

  return (
        <div className="flex-col p-8 bg-white">
          <div className="flex-1 overflow-y-auto">
            <h2 className="text-xl font-semibold mb-6">Payment</h2>
            {!formIsComplete && (
              <p className="text-sm text-gray-600 mb-4"><b>
                For Payment, as required from the lender, you will be redirected to your web browser. Click here when you are ready to proceed
              </b></p>
            )}
            {formIsComplete && (
              <p className="text-sm text-gray-600 mb-4"><b>
                Payment status: {paymentStatus}<br></br>Payment ID: {paymentId}
              </b></p>
            )}
            {formIsComplete2 && (
              <Loader2 />
            )}
          </div>
      

          <div className="mt-6">
            {!formIsComplete && !formIsComplete2 && (
            <button className={`w-full px-8 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition
              ${formIsComplete 
                ? "bg-gray-400 cursor-not-allowed" 
                : "bg-blue-600 text-white hover:bg-blue-700"}`}
            onClick={() => openPopup()}
            disabled={formIsComplete}
            >
              Make Payment 
            </button>)}
            {formIsComplete && (
            <button className={`w-full px-8 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition
              ${!formIsComplete 
                ? "bg-gray-400 cursor-not-allowed" 
                : "bg-blue-600 text-white hover:bg-blue-700"}`}
              onClick={() => onClickEvent()}
              disabled={!formIsComplete}
              >
                My Loans
              </button>
            )}
          </div>
        </div>
  );
}

export default function PaymentScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    validateLogin(navigate);
  }, [navigate]);

  return (
    // <main className="flex-1 overflow-y-auto flex items-center justify-center bg-[#f5f9ff] px-4">
      <Form />
    // </main>
  );
}
